import chroma from "chroma-js"
import { ThemeVariant } from "../types"
import { Nullable } from "../types/utils"

export function mixTwoColors(
  base: string,
  incoming: string,
  percentage: number,
) {
  return chroma(base).mix(incoming, percentage).hex()
}

export function setColorAlpha(color: string, alpha: number) {
  return chroma(color).alpha(alpha).hex()
}

export function patchColorContrast(
  color: Nullable<string>,
  theme: ThemeVariant,
) {
  if (!color) {
    return null
  }

  const backgroundColor = theme === "light" ? "#FFFFFF" : "#000000"

  const contrast = chroma.contrast(color, backgroundColor)
  if (contrast < 1.5) {
    const [r, g, b] = chroma(color).rgb()

    return chroma.rgb(255 - r, 255 - g, 255 - b).hex()
  }

  return color
}
